import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { Attachment } from "src/app/_api/models/attachment.model";
import { LanguageService } from "src/app/shared/services/language.service";

@Component({
  selector: "app-project-portal-approval-attachment",
  templateUrl: "./project-portal-approval-attachment.component.html",
  styleUrls: ["./project-portal-approval-attachment.component.css"],
})
export class ProjectPortalApprovalAttachmentComponent implements OnInit {
  @Input() selectedTimeRecord: any;
  @Input() selectedDateInterval: any;
  attachment: Attachment;
  attachmentWork: any[]; 
  allowEdit: boolean = true; 
  labelTemplate: Object; 
  isClone: boolean = false;
  cloneData: any;
  @Input() projectReadWriteAll: boolean; 
  @Input() selectedProjectId: number; 

  @ViewChild("datagriddx", { static: false })
  attachmentWorkGrid: DxDataGridComponent;

  constructor(public languageService: LanguageService) {
  }

  // Test-data. 
  getAttachment() {
    const attachment: Attachment = {
      AttachmentNumber: 456789,
      Name: "398-SYZA-GAD-105100-Harvard-Mooring hauling",
      Customer: "10264 - Nybygg supergate",
      Task: "Per buskerud",
      RekvNo: "20546",
      Comment: "Svært glatte veier. Jabra og logi møtte han power. Det hender når man minst forventet resultatet skulle bli levert.",
    };

    return attachment;
  }

  ngOnInit(): void {
    this.attachment = this.getAttachment();
    this.allowEdit = this.projectReadWriteAll
  }

  onEditorPreparing(e) {}
  onEditingStart(e) {}
  onSavingMultiple(e) {}
  onInitNewRow(e) {}
  onCellPrepared(e) {}

  onToolbarPreparing(e) {
    if (this.allowEdit) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'headerTitle'
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "copy",
            title: this.languageService.LNG("Label.Copy"),
            onClick: this.onCopySelected.bind(this),
          },
        },
        {
          location: "after",
          widget: "dxButton",
          options: {
            icon: "trash",
            title: this.languageService.LNG("Label.Delete"),
            onClick: this.onDeleteSelected.bind(this),
          },
        }
      );
    }
    else {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: 'headerTitle'
        });
    }
  }

  onCopySelected() {
    let selectedRowsData = this.attachmentWorkGrid.instance.getSelectedRowsData();
    if (selectedRowsData.length > 0) {
      for (let i = 0; i < selectedRowsData.length; i++) {
        this.isClone = true;
        this.cloneData = selectedRowsData[i];
        this.attachmentWorkGrid.instance.addRow();
      }
    }
  }

  onDeleteSelected() {}

  onSelectionChanged(e) {}

}
